import { Component, OnInit, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'angula4x-auto-complete',
  template: `
<div class="ngxautocomplete">
  <div #_ng_autocomp_selected_list class="list_container"></div>
  <input type="text" value="" name="ngx-autocomplete_field" (keyup)="getData($event)" #_ng_autocomp_txt>
  <div #_ng_autocom_list class="ngx-auto-list"></div>
  <i class="fa fa-cog fa-spin" [style.visibility]="_loading" ></i>
</div>`,
  styles: [`:focus{outline:0}.ngxautocomplete{position:relative;width:100%;border:1px solid #ccc}.ngxautocomplete .list_container{width:100%;float:left}.ngxautocomplete input{border:0;width:90%}.ngx-auto-list{display:none;position:absolute;width:100%;min-height:300px;overflow-y:scroll;border-left:1px solid #ccc;border-right:1px solid #ccc;border-bottom:1px solid #ccc;top:0;background:#fff;z-index:99}.ngxautocomp_list_el{text-align:left;cursor:pointer;padding:5px}.ngxautocomp_list_el:hover{background-color:#ccc}.ngxautocomplete .selected_div{background-color:#d0e1ec;border:1px solid #d0e1ec;border-radius:10px;padding:5px;margin:3px;width:auto;float:left}.ngxautocomplete .selected_div .remove_div{cursor:pointer;margin-left:4px;border:1px solid #7c7a7a;padding:0 2px 5px;color:#2c2b2b;text-align:center;font-size:13px;line-height:17px;border-radius:100px;width:14px;height:14px;background:#fff;float:right;font-family:Arial,Helvetica,sans-serif}.ngxautocomplete .selected_div .remove_div:hover{color:#ec0606;border:1px solid #ec0606}`]
})
export class Angula4xAutoCompleteComponent {
  data_url:any;
  db_fields:any;
  all_list_child=[];
  selected_row=[]
  selected_row_obj={}
  _loading:string="hidden";
  @ViewChild('_ng_autocom_list') list:ElementRef;
  @ViewChild('_ng_autocomp_txt') text_fld:ElementRef;
  @ViewChild('_ng_autocomp_selected_list') list_div:ElementRef;
  constructor(protected http:HttpClient,protected renderer:Renderer2) { }
  setting(setting_obj){
    this.data_url=setting_obj.data_url;
    this.db_fields= setting_obj.db_fields;
    //console.log(this.data_url)
  }
  

  @HostListener('document:click')
  clickout() {
    
     this._clearList()
  }
  getData(event){
        let input_val= event.target.value
              
        if(input_val.length==0){
          this._clearList();
           return
        }
        let final_url=this.data_url+'?q='+input_val
        this._loading="visible"
        this.http.get(final_url).subscribe(todo=>{
              this._clearList()
              for(let k in todo){
                let new_div=this.renderer.createElement('div');
                let field_array=this.db_fields.split(",")
                let display_text=""
                for(var i=0;i<field_array.length;i++){
                  display_text+=todo[k][field_array[i]]+" ";
                }
                display_text=display_text.trim();
                
                this.renderer.appendChild(new_div,this.renderer.createText(display_text));
                
                this.all_list_child.push(new_div)
                this.renderer.listen(new_div,'click',(event)=>{
                  //this.text_fld.nativeElement.value=event.target.innerHTML
                 
                  let tindex=Array.from(event.target.parentNode.children).indexOf(event.target)
                  let id=todo[tindex].id
                  for(let row of this.selected_row){
                    if(row.id==id){
                      this.text_fld.nativeElement.value=""
                      return
                    }
                   
                }
                  //this.selected_row.push(todo[tindex])
                  this.selected_row_obj[display_text]=todo[tindex];
                  //console.log(this.selected_row_obj);
                  let select_new_div=this.renderer.createElement('div');
                  let remove_new_div=this.renderer.createElement('div');
                  
                  this.renderer.appendChild(remove_new_div,this.renderer.createText("x"))
                  this.renderer.addClass(remove_new_div,'remove_div')
                  this.renderer.setAttribute(remove_new_div,"id",display_text+"_"+"elem_autocomp")
                  this.renderer.addClass(select_new_div,"selected_div")
                  this.renderer.appendChild(select_new_div,remove_new_div)
                  this.renderer.appendChild(select_new_div,this.renderer.createText(event.target.innerHTML))
                  this.renderer.listen(remove_new_div,'click',(event)=>{
                      let id=event.target.id.split("_")[0]
                      let i=0;
                      delete this.selected_row_obj[id]
                      this.renderer.removeChild(this.list_div.nativeElement,event.target.parentNode)
                      //console.log(this.selected_row_obj);
                  })
                  this.text_fld.nativeElement.value=""
                  this.renderer.appendChild(this.list_div.nativeElement,select_new_div)
                })
                this.renderer.appendChild(this.list.nativeElement,new_div)
                
                
                var theight=this.text_fld.nativeElement.parentElement.offsetHeight
                
                this.renderer.setStyle(this.list.nativeElement,"top",theight+"px")
                this.renderer.setStyle(this.list.nativeElement,"display","block")
                  
                this.renderer.addClass(new_div,"ngxautocomp_list_el")
              }
              this._loading="hidden"
        })

  } 

  private _clearList(){
    for(let i=0;i<this.all_list_child.length;i++)
        this.renderer.removeChild(this.list.nativeElement,this.all_list_child[i])
    this.all_list_child=[];     
    this.renderer.setStyle(this.list.nativeElement,"display","none")
  }

  getSelectedRow():string{
    let i=0;
    this.selected_row=[];
    for(let row in this.selected_row_obj){
      this.selected_row[i++]=this.selected_row_obj[row];
    }
     return JSON.stringify(this.selected_row);
  }

}
